import React from "react";
import * as yup from "yup";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useFormik } from "formik";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import { InputPhone } from "../../../../../../shared/InputPhone/InputPhone";
import classes from "../scss/ClientWalletSunbit.module.scss";
import { Modal } from "../../../../../../shared/Modal/Modal";
import { Button } from "../../../../../../shared/Button/Button";
import { useSunbitEnroll } from "../hooks/useSunbitEnroll";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../services/UINotificationService";

const SunbitEnrollModal = ({ onClose, clientPhoneNumber, clientId }) => {
  const { tSales } = useAppTranslation.Sales();

  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    validationSchema: yup.object({
      phoneNumber: yup
        .string()
        .required()
        .test(
          "valid-phone-number",
          tSales("checkoutInvoice.formError.validPhoneNumberRequired"),
          function (value) {
            return isValidPhoneNumber(
              value || "",
              this.parent.country?.countryCode.toUpperCase(),
            );
          },
        ),
    }),
    initialValues: {
      phoneNumber: clientPhoneNumber || "",
    },

    onSubmit: (values) => {
      mutate(
        {
          phone: values.phoneNumber,
        },
        {
          onSuccess: (response) => {
            onClose();
            uiNotification.success(response.data.message);
          },
          onError: (error) => uiNotification.error(error.response.data.message),
        },
      );
    },
  });

  const { mutate, isLoading } = useSunbitEnroll(clientId);

  return (
    <Modal
      isOpen
      onClose={onClose}
      header={<Modal.Title>Sunbit Pre-qualification</Modal.Title>}
      footerNoBorder
      footer={
        <div className={classes.footerContainer}>
          <Button size="small" variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            onClick={handleSubmit}
            isDisabled={isLoading}
            leftAdornment={
              isLoading && <CircularProgress size="tiny" color="white" />
            }
          >
            Prequalify
          </Button>
        </div>
      }
    >
      <div className={classes.phoneForm}>
        <InputLabel>Phone Number</InputLabel>
        <InputPhone
          withSearch
          fullWidth
          variant="legacy-outlined"
          value={values.phoneNumber}
          onChange={(value, country, e, formattedPhone) => {
            setFieldValue("phoneNumber", formattedPhone);
          }}
          isError={Boolean(errors.phoneNumber)}
        />
      </div>
    </Modal>
  );
};

export default SunbitEnrollModal;
